import { useEffect, useState } from "react";
import { Rocket } from "lucide-react";
import { api } from "@/lib/api";
import { useLandingLang } from "@/components/FundingCaseStudy";

const T = {
  en: { eyebrow: "Alpha Founder Cohort", title: "Stories from early members", challenge: "The challenge", approach: "How they use GrantVerify", progress: "Where things stand", note: "Written with each member and approved by them before publishing." },
  es: { eyebrow: "Cohorte Alfa de Fundadores", title: "Historias de los primeros miembros", challenge: "El reto", approach: "Cómo usan GrantVerify", progress: "Dónde están ahora", note: "Escritas con cada miembro y aprobadas por ellos antes de publicarse." },
};

export function CohortStories() {
  const lang = useLandingLang();
  const L = T[lang];
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/public/cohort-cases", { params: { lang: lang === "es" ? "es" : "" } }).then((r) => setRows(r.data)).catch(() => {}); }, [lang]);
  if (!rows.length) return null;
  return (
    <section className="border-b border-slate-200 bg-white" data-no-translate lang={lang} data-testid="cohort-stories">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="eyebrow mb-3 flex items-center gap-2"><Rocket className="h-4 w-4" />{L.eyebrow}</div>
        <h2 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight text-slate-900">{L.title}</h2>
        <div className="mt-10 grid md:grid-cols-2 gap-6">{rows.map((c, i) => (
          <article key={c.case_id} className="border border-slate-200 rounded-lg p-6 sm:p-8 card-lift" data-testid={`cohort-story-${i}`}>
            <div className="text-xs font-mono uppercase tracking-[0.15em] text-slate-500">{c.business}{c.state ? ` · ${c.state}` : ""}</div>
            <h3 className="font-display text-xl font-bold text-slate-900 mt-2">{c.title}</h3>
            {[["challenge", L.challenge], ["approach", L.approach], ["progress", L.progress]].map(([k, l]) => <div key={k} className="mt-4"><div className="text-[11px] font-semibold uppercase tracking-wider text-emerald-700">{l}</div><p className="text-sm text-slate-700 mt-1">{c[k]}</p></div>)}
            {c.quote && <blockquote className="mt-5 border-l-4 border-emerald-500 pl-4 italic text-slate-800">“{c.quote}”<div className="not-italic text-xs text-slate-500 mt-1">{c.name}, {c.business}</div></blockquote>}
          </article>))}</div>
        <p className="mt-6 text-xs text-slate-400">{L.note}</p>
      </div>
    </section>
  );
}
